import { render, staticRenderFns } from "./SdpPrinterHealthBanner.vue?vue&type=template&id=b1b2bdac&scoped=true&"
import script from "./SdpPrinterHealthBanner.vue?vue&type=script&lang=js&"
export * from "./SdpPrinterHealthBanner.vue?vue&type=script&lang=js&"
import style0 from "./SdpPrinterHealthBanner.vue?vue&type=style&index=0&id=b1b2bdac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b2bdac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
